<div class="container-lg px-0">
  <app-header-nav [hideMenu]="hideMenu" [hideSearch]="hideSearch"></app-header-nav>
</div>
